// libs
import React, { useState, useRef, useEffect } from 'react';

//components
import CategoryPopUp from 'shared/components/Filter/components/CategoryPopUp';
import ButtonsContainer from 'shared/components/Filter/components/ButtonsContainer';
import CollapsedFilter from 'shared/components/Filter/components/CollapsedFilter';

//styles
import { Container, PopUpWrapper, Subheading, Wrapper } from './styles';

//helpers
import {
  isSameArray,
  getUpdatedFilters,
  getBulkUpdatedFilters,
} from 'shared/components/Filter/helpers';

//defs
interface CategoryViewProps {
  filter: Listing.IFilter;
  onApplyClick: (value: string) => VoidFunction;
  checkedFilters: string[];
  isCollapsedView: boolean;
  onClick: () => VoidFunction;
}

function TreeView({
  filter,
  onApplyClick,
  checkedFilters,
  isCollapsedView,
  onClick,
}: CategoryViewProps) {
  const { title, values, message } = filter;
  const [selectedOptions, setSelectedOptions] = useState(checkedFilters);

  const popupRef = useRef<HTMLDivElement>(null);

  const onValueSelection = (item: string) => {
    setSelectedOptions(getUpdatedFilters(selectedOptions, true, item));
  };

  const onShopAllClick = (items: string[], isAllSelected: boolean) => {
    setSelectedOptions(getBulkUpdatedFilters(selectedOptions, items, isAllSelected));
  };

  useEffect(() => {
    if (isCollapsedView && !isSameArray(selectedOptions, checkedFilters))
      setSelectedOptions(checkedFilters);
  }, [checkedFilters, isCollapsedView, selectedOptions]);

  useEffect(() => {
    if (!isCollapsedView) {
      popupRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isCollapsedView]);

  return (
    <Wrapper>
      <CollapsedFilter
        title={title}
        isCollapsedView={isCollapsedView}
        onArrowClick={onClick}
        selectedFiltersCount={checkedFilters.length}
        isOverlayFilter
      />
      {message && <Subheading>{message}</Subheading>}
      {!isCollapsedView && (
        <Container ref={popupRef}>
          <PopUpWrapper>
            <CategoryPopUp
              values={values}
              selectedOptions={selectedOptions}
              onValueSelection={onValueSelection}
              onShopAllClick={onShopAllClick}
            />
          </PopUpWrapper>

          <ButtonsContainer
            onApplyClick={onApplyClick}
            collapseFilter={onClick}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            isApplyButtonDisabled={isSameArray(selectedOptions, checkedFilters)}
          />
        </Container>
      )}
    </Wrapper>
  );
}

export default TreeView;
